import "normalize.css";
import { createBrowserHistory } from "history";
import noop from "lodash/noop";
import React from "react";
import ReactDOM from "react-dom";
import App from "@Components/App";
import SmartAppBanner from "@Components/atoms/SmartAppBanner";
import BannerKountries from "@Components/molecules/BannerKountries";
import NotificationsArea from "@Components/molecules/cart/NotificationsArea";
import LoginModal from "@Components/molecules/LoginModal";
import NotificationsProvider from "@Components/NotificationsStateProvider";
import Footer from "@Components/organisms/Footer";
import Header from "@Components/organisms/Header";
import WithLocale from "@Components/WithLocale";
import { isAppWebView } from "@Utils/device";
import { WithBugsnag } from "./bugsnag";
import "./index.scss";

const history = createBrowserHistory();

const rootElement = document.getElementById("root");

if (rootElement) {
  ReactDOM.render(
    <WithBugsnag>
      <App />
    </WithBugsnag>,
    rootElement
  );
}

const bannerKountriesElement = document.getElementById("BannerKountriesComponent");

if (bannerKountriesElement) {
  ReactDOM.render(
    <WithBugsnag>
      <WithLocale history={history}>
        <BannerKountries />
      </WithLocale>
    </WithBugsnag>,
    bannerKountriesElement
  );
}

const headerElement = document.getElementById("HeaderComponent");

if (headerElement && !isAppWebView()) {
  ReactDOM.render(
    <WithBugsnag>
      <WithLocale history={history}>
        <NotificationsProvider>
          <Header />
          <div className="Header-notifications">
            <NotificationsArea />
          </div>
        </NotificationsProvider>
      </WithLocale>
    </WithBugsnag>,
    headerElement
  );
}

const smartAppBannerElement = document.getElementById("SmartAppBannerComponent");

if (smartAppBannerElement) {
  ReactDOM.render(
    <WithBugsnag>
      <SmartAppBanner />
    </WithBugsnag>,
    smartAppBannerElement
  );
}

const loginModalElement = document.getElementById("LoginModalComponent");

if (loginModalElement) {
  ReactDOM.render(
    <WithBugsnag>
      <WithLocale history={history}>
        <NotificationsProvider>
          <LoginModal action="signIn" display={true} hide={noop} />
          <div className="Header-notifications">
            <NotificationsArea />
          </div>
        </NotificationsProvider>
      </WithLocale>
    </WithBugsnag>,
    loginModalElement
  );
}

const footerElement = document.getElementById("FooterComponent");

if (footerElement) {
  ReactDOM.render(
    <WithBugsnag>
      <WithLocale history={history}>
        <Footer />
      </WithLocale>
    </WithBugsnag>,
    footerElement
  );
}
